/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectActivityResourcePendingActionsInner
 */
export interface ProjectActivityResourcePendingActionsInner {
    /**
     * 
     * @type {string}
     * @memberof ProjectActivityResourcePendingActionsInner
     */
    actionType: ProjectActivityResourcePendingActionsInnerActionTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ProjectActivityResourcePendingActionsInner
     */
    dueDate: Date;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProjectActivityResourcePendingActionsInner
     */
    extraData: { [key: string]: string; };
}


/**
 * @export
 */
export const ProjectActivityResourcePendingActionsInnerActionTypeEnum = {
    ActivityReportPendingApproval: 'ACTIVITY_REPORT_PENDING_APPROVAL',
    AddProjectToProfile: 'ADD_PROJECT_TO_PROFILE',
    AwaitingProjectClientCompletion: 'AWAITING_PROJECT_CLIENT_COMPLETION',
    CheckBlockedExpenses: 'CHECK_BLOCKED_EXPENSES',
    CompleteProject: 'COMPLETE_PROJECT',
    LeaveAppraisal: 'LEAVE_APPRAISAL',
    MonthPrepaymentReceived: 'MONTH_PREPAYMENT_RECEIVED',
    PendingComplianceDocuments: 'PENDING_COMPLIANCE_DOCUMENTS',
    ProjectPrepaymentReceived: 'PROJECT_PREPAYMENT_RECEIVED',
    RenewProject: 'RENEW_PROJECT',
    RequestMonthClientPrepayment: 'REQUEST_MONTH_CLIENT_PREPAYMENT',
    RequestProjectClientPrepayment: 'REQUEST_PROJECT_CLIENT_PREPAYMENT',
    ReviewContractChanges: 'REVIEW_CONTRACT_CHANGES',
    SendComplianceDocuments: 'SEND_COMPLIANCE_DOCUMENTS',
    SubmitActivityReport: 'SUBMIT_ACTIVITY_REPORT',
    TermsReviewRequested: 'TERMS_REVIEW_REQUESTED'
} as const;
export type ProjectActivityResourcePendingActionsInnerActionTypeEnum = typeof ProjectActivityResourcePendingActionsInnerActionTypeEnum[keyof typeof ProjectActivityResourcePendingActionsInnerActionTypeEnum];


/**
 * Check if a given object implements the ProjectActivityResourcePendingActionsInner interface.
 */
export function instanceOfProjectActivityResourcePendingActionsInner(value: object): value is ProjectActivityResourcePendingActionsInner {
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('extraData' in value) || value['extraData'] === undefined) return false;
    return true;
}

export function ProjectActivityResourcePendingActionsInnerFromJSON(json: any): ProjectActivityResourcePendingActionsInner {
    return ProjectActivityResourcePendingActionsInnerFromJSONTyped(json, false);
}

export function ProjectActivityResourcePendingActionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectActivityResourcePendingActionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'actionType': json['actionType'],
        'dueDate': (new Date(json['dueDate'])),
        'extraData': json['extraData'],
    };
}

export function ProjectActivityResourcePendingActionsInnerToJSON(value?: ProjectActivityResourcePendingActionsInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'actionType': value['actionType'],
        'dueDate': ((value['dueDate']).toISOString()),
        'extraData': value['extraData'],
    };
}

